/**
 * データのグルーピング
 * @param {Array.<Object>} data データ
 * @param {String} key グルーピングするキー
 * @returns {Array.<Object>} 結果
 */
export const groupData = (data, key) => {
  const groups = {}
  for (const d of data) {
    if (!groups[d[key]]) {
      groups[d[key]] = []
    }
    groups[d[key]].push(d)
  }
  return Object.entries(groups).map(([keyValue, dataValue]) => {
    const k = isNaN(+keyValue) ? keyValue : +keyValue
    return { [key]: k, data: dataValue }
  })
}
